import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./SubscriptionLandingPage.scss";
import {
  getSubscriptionPlans,
  paymentRequest,
} from "../../services/subscriptionService";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { dateParserWithoutTime } from "../../helper";
import { UI_SERVER_PATH } from "../../server-data";

const SubscriptionLandingPage = (props: any) => {
  let { formIframe, open, onClose, showCloseIcon } = props;
  formIframe = !!formIframe;
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const formIframe = !!queryParams.get("website");
  const subscription = useSelector((state: any) => state.sub.subscription);
  const baseCurrency = "USD";
  const [subscriptionPlanDetails, setSubscriptionPlanDetails] = useState<any>(
    []
  );
  const [currectSubscription, setSurrectSubscription] = useState<any>({});

  useEffect(() => {
    setSurrectSubscription(subscription);
  }, [subscription]);

  useEffect(() => {
    getSubscriptionPlans().then((res: any) => {
      if (res?.data?.plans?.length) {
        setSubscriptionPlanDetails(
          res.data.plans.filter((eachPlan: any) =>
            formIframe
              ? eachPlan.plan_code === "lite" || eachPlan.plan_code === "trans"
              : subscription?.planCode === eachPlan.plan_code
          )
        );
      }
    });
  }, []);

  const onClickPayment = () => {
    paymentRequest().then((res: any) => {
      let data = res?.data?.data;
      let paymentUrl = data?.url;
      if (paymentUrl) {
        window.open(paymentUrl, "_self");
      }
    });
  };

  const onIframeSubscribe = (planCode: any) => {
    let path = UI_SERVER_PATH() + "/auth/register?plan=";
    path += planCode;
    window.open(path, "_blank");
  };

  const renderMultiLineDescription = (description: any) => {
    let parsedFeatures = [];
    try {
      const parsedJson = JSON.parse(description);
      if (parsedJson.features) {
        parsedFeatures = parsedJson.features.map(
          (feature: any) => feature.name
        );
      }
    } catch (e) {
      parsedFeatures = description.split("|");
    }
    const descriptionLines = parsedFeatures.map((part: any, index: any) => (
      <React.Fragment key={index}>
        <div className="grow shrink basis-0 h-12 px-3 py-4 bg-white justify-start items-center gap-2 flex">
          <img src="assets/icons/check.svg" alt=" " />
          <div className="text-neutral-800 text-sm font-normal font-['Proxima Nova'] leading-tight">
            {part}
          </div>
        </div>
      </React.Fragment>
    ));
    return <div>{descriptionLines}</div>;
  };

  return (
    <Fragment>
      {!formIframe ? (
        <>
          {(showCloseIcon ? open : true) && (
            <div>
              <Dialog className="pw-dialog-subscription" open={true}>
                <div className="p-10 bg-gray-50 shadow flex-col justify-start items-center gap-6 inline-flex">
                  <div className="self-stretch h-28 flex-col justify-center items-start gap-2 flex">
                    <div className="self-stretch justify-between items-start inline-flex">
                      <div className="w-96 h-8 text-neutral-800 text-2xl font-bold font-['Proxima Nova']">
                        Welcome User,
                      </div>
                      {showCloseIcon && (
                        <div className="cursor-pointer">
                          <CloseIcon
                            className="pw-color-close-attchments"
                            onClick={onClose}
                          />
                        </div>
                      )}
                    </div>
                    <div className="self-stretch h-px border border-zinc-200"></div>
                    {subscription &&
                    subscription?.status === "trial" &&
                    !subscription?.isExpired ? (
                      <div className="h-20 text-neutral-700 text-sm font-normal font-['Proxima Nova'] leading-tight">
                        Your trial ends on{" "}
                        {subscription?.currentTermEndsAt
                          ? dateParserWithoutTime(
                              subscription.currentTermEndsAt
                            )
                          : ""}
                        , and your subscription starts/renews from{" "}
                        {subscription?.nextBillingAt
                          ? dateParserWithoutTime(subscription.nextBillingAt)
                          : ""}
                        . <br />
                        <br />
                        Disclaimer: Your card details will be collected if you
                        proceed further. Your payment will be automatically
                        deducted on{" "}
                        {subscription?.nextBillingAt
                          ? dateParserWithoutTime(subscription.nextBillingAt)
                          : ""}{" "}
                        (at the actual renewal time), and your subscription will
                        be automatically renewed.
                      </div>
                    ) : (
                      subscription &&
                      subscription?.status !== "live" && (
                        <div className="text-neutral-700 text-sm font-normal font-['Proxima Nova'] leading-tight">
                          Your trial ended on{" "}
                          {subscription?.currentTermEndsAt
                            ? dateParserWithoutTime(
                                subscription.currentTermEndsAt
                              )
                            : ""}
                          . Subscribe now to continue using PlanetWise.
                        </div>
                      )
                    )}
                  </div>
                  <div className="self-stretch justify-center gap-4 inline-flex">
                    {subscriptionPlanDetails.map((plan: any) => (
                      <div
                        key={plan.plan_id}
                        className={`pw-max-w-50 grow shrink basis-0 pb-4 bg-white rounded-2xl shadow flex-col justify-start items-center inline-flex 
                    ${
                      subscription?.planCode === plan.plan_code &&
                      "border-green-500 border-4"
                    }
                    `}
                      >
                        <div className="self-stretch px-2 pt-4 pb-2 bg-white rounded-2xl flex-col justify-start items-center gap-4 flex">
                          <div className="text-neutral-800 text-xl font-bold font-['Proxima Nova']">
                            {plan.name}
                          </div>
                          <div className="flex-row justify-center items-center gap-2 flex">
                            <div className="text-neutral-800 text-xl font-semibold font-['Proxima Nova']">
                              {baseCurrency}
                            </div>
                            <div className="text-neutral-800 text-3xl font-semibold font-['Proxima Nova']">
                              {plan.recurring_price}
                            </div>
                            <div className="text-slate-700 text-sm font-normal font-['Proxima Nova'] leading-tight">
                              per {plan.interval_unit.slice(0, -1)}
                            </div>
                          </div>
                          {/* <div className="flex-row justify-center items-center gap-1 flex text-neutral-600 -mt-2">
                            <div className=" text-xs font-normal font-['Proxima Nova']">
                              {baseCurrency}
                            </div>
                            <div className="text-xs font-normal font-['Proxima Nova']">
                              {((plan.recurring_price || 0) / 12).toFixed(2)}
                            </div>
                            <div className="text-xs font-normal font-['Proxima Nova'] leading-tight">
                              per month
                            </div>
                          </div> */}
                        </div>
                        {subscription?.planCode === plan.plan_code &&
                        subscription?.status !== "live" ? (
                          <div className="self-stretch px-8 py-3 bg-white justify-center items-start gap-2 inline-flex">
                            <div
                              className="grow shrink basis-0 h-8 bg-green-500 rounded justify-center items-center flex cursor-pointer"
                              onClick={onClickPayment}
                            >
                              <div className="w-full px-4 py-1 justify-center items-center gap-2 flex">
                                <div className="text-white text-xs font-bold font-['Proxima Nova']">
                                  Add Card
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="self-stretch px-8 py-3 bg-white justify-center items-start gap-2 inline-flex invisible h-auto">
                            <div className="grow shrink basis-0 h-8 bg-green-500 rounded justify-center items-center flex cursor-pointer">
                              <div className="w-full px-4 py-1 justify-center items-center gap-2 flex">
                                <div className="text-white text-xs font-bold font-['Proxima Nova']">
                                  Subscribe Now
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* <div className="self-stretch px-8 pb-2 bg-white justify-center items-start gap-2 inline-flex">
                      <div className="grow shrink basis-0 h-7 bg-white rounded justify-center items-center flex">
                        <div className="px-4 py-1 justify-center items-center gap-2 flex">
                          <div className="text-green-400 text-xs font-bold font-['Proxima Nova']">
                            {plan.trial_period} Day free trial
                          </div>
                        </div>
                      </div>
                    </div> */}
                        <div className="self-stretch justify-center items-start inline-flex">
                          {renderMultiLineDescription(
                            plan.store_markup_description
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Dialog>
            </div>
          )}
        </>
      ) : (
        <div className="py-8">
          <div className="self-stretch justify-start gap-16 flex flex-row justify-center">
            {subscriptionPlanDetails.map((plan: any) => (
              <div
                key={plan.plan_id}
                className={`grow shrink basis-0 pb-4 bg-white rounded-2xl shadow flex-col justify-start max-w-sm items-center inline-flex 
                `}
              >
                <div className="self-stretch px-2 pt-4 pb-2 bg-white rounded-2xl flex-col justify-start items-center gap-4 flex">
                  <div className="text-neutral-800 text-xl font-bold font-['Proxima Nova']">
                    {plan.name}
                  </div>
                  <div className="flex-row justify-center items-center gap-2 flex">
                    <div className="text-neutral-800 text-xl font-semibold font-['Proxima Nova']">
                      {baseCurrency}
                    </div>
                    <div className="text-neutral-800 text-3xl font-semibold font-['Proxima Nova']">
                      {plan.recurring_price}
                    </div>
                    <div className="text-slate-700 text-sm font-normal font-['Proxima Nova'] leading-tight">
                      per {plan.interval_unit.slice(0, -1)}
                    </div>
                  </div>
                  {/* <div className="flex-row justify-center items-center gap-1 flex text-neutral-600 -mt-2">
                    <div className="text-xs font-normal font-['Proxima Nova']">
                      {baseCurrency}
                    </div>
                    <div className="text-xs font-normal font-['Proxima Nova']">
                      {((plan.recurring_price || 0) / 12).toFixed(2)}
                    </div>
                    <div className="text-xs font-normal font-['Proxima Nova'] leading-tight">
                      per month
                    </div>
                  </div> */}
                </div>
                <div className="self-stretch px-8 py-3 bg-white justify-center items-start gap-2 inline-flex">
                  <div
                    className="grow shrink basis-0 h-8 pw-primary-website-background-color rounded justify-center items-center flex cursor-pointer"
                    onClick={() => {
                      onIframeSubscribe(plan.plan_code);
                    }}
                  >
                    <div className="w-full px-4 py-1 justify-center items-center gap-2 flex">
                      <div className="text-white text-xs font-bold font-['Proxima Nova']">
                        Subscribe Now
                      </div>
                    </div>
                  </div>
                </div>
                <div className="self-stretch justify-center items-start inline-flex">
                  {renderMultiLineDescription(plan.store_markup_description)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default SubscriptionLandingPage;
